export const faqs = [
  {
    question: 'What types of projects does ANR Mechanical handle?',
    answer:
      'We deliver HVAC and mechanical scopes for commercial, institutional, government, healthcare, and mission-critical facilities throughout the New York metro region.',
  },
  {
    question: 'Do you provide design-build as well as plan-spec work?',
    answer:
      'Yes. We partner with owners and GCs for design-build, design-assist, and plan-spec projects, tailoring deliverables to each contract type.',
  },
  {
    question: 'Which regions do you serve?',
    answer:
      'Our core market is NYC, Long Island, and the greater NY/NJ/CT area, with select projects in the Northeast.',
  },
  {
    question: 'What is your bonding capacity?',
    answer: 'We maintain $5M Single / $10M Aggregate bonding capacity with leading sureties.',
  },
  {
    question: 'Are you certified as an MBE?',
    answer:
      'Yes. ANR is MBE certified with the Port Authority NY/NJ, NYC SBS, and New York State.',
  },
  {
    question: 'Do you work in occupied or critical environments?',
    answer:
      'Our crews specialize in occupied renovations, phased cutovers, and critical environments requiring strict safety and infection control.',
  },
];
